import { types, actions } from './requests'
export const GETTASK_TYPES = {
    ...types('GETTASK'),
}
export const GETTASK_ACTIONS = {
    ...actions('GETTASK'),
}